import * as React from 'react';
import { cn } from '@/utils/cn';
import type { WordTimestamp } from './KaraokePlayer.types';
import styles from './KaraokePlayer.module.scss';

export interface InlineKaraokeWordsProps {
  timestamps: WordTimestamp[];
  currentTime: number;
  isPlaying: boolean;
  hasEnded?: boolean;
  /** Añade tipografía compacta (p. ej. burbujas de chat) */
  className?: string;
}

/**
 * Misma lógica visual que el transcript del KaraokePlayer (palabra actual resaltada).
 */
export function InlineKaraokeWords({ timestamps, currentTime, isPlaying, hasEnded, className }: InlineKaraokeWordsProps) {
  const currentWordIndex = React.useMemo(
    () => timestamps.findIndex((t) => currentTime >= t.start && currentTime <= t.end),
    [timestamps, currentTime]
  );

  const isDone = hasEnded ?? (!isPlaying && currentTime > 0);

  if (timestamps.length === 0) return null;

  return (
    <div className={cn(styles.karaokePlayer__transcript, className)}>
      {timestamps.map((item, i) => {
        if (item.word === '\n') {
          return <br key={i} />;
        }
        const isPast = isDone || currentTime > item.end;
        const isCurrent = !isDone && isPlaying && currentWordIndex === i;
        return (
          <React.Fragment key={i}>
            <span
              className={cn(
                styles.karaokePlayer__word,
                isPast && styles['karaokePlayer__word--past'],
                isCurrent && styles['karaokePlayer__word--current'],
                isDone && styles['karaokePlayer__word--done']
              )}
            >
              {item.word}
            </span>
            {item.lineBreakAfter ? <br /> : null}
            {!item.lineBreakAfter && i < timestamps.length - 1 && timestamps[i + 1]?.word !== '\n' ? ' ' : ''}
          </React.Fragment>
        );
      })}
    </div>
  );
}
